import styled from '@emotion/styled';
import { BREAKPOINT_SMALL } from 'client/components/MarketingPagesShared/styles';

const Details = styled.details`
  width: 100%;
  max-width: 790px;
  margin-bottom: 50px;
  padding-left: 30px;
  font-size: 1.8rem;
  line-height: 30px;
  svg {
    position: absolute;
    top: 8px;
    left: -28px;
    margin-right: 15px;
  }
  summary {
    position: relative;
    font-weight: bold;
    cursor: pointer;
    &::-webkit-details-marker {
      display: none;
    }
  }
`;

const Container = styled.section`
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  padding: 150px 24px;
  h2 {
    margin: 0 0 50px;
    font-weight: 900;
    font-size: 3.6rem;
  }
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 100px 24px;
    h2 {
      font-size: 2.8rem;
    }
  }
`;

export { Details, Container };
